import { $t } from '@/i18n'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'
import message from '@/components/message'

export default {
  namespace: true,
  state: {
    suggestedLoadingState: false,
    listSuggestedReviews: [
      {
        id: 1,
        name: 'Facebook',
        link: '',
        checked: false,
        mail: {
          subject: $t('socialReviews.objectMail') + 'Facebook',
          content: {
            sir: $t('socialReviews.sir'),
            contentMail: '',
            deviseMail: $t('socialReviews.deviseMail'),
            sincerely: $t('socialReviews.sincerely')
          }
        }
      },
      {
        id: 2,
        name: 'Google',
        link: '',
        checked: false,
        mail: {
          subject: $t('socialReviews.objectMail') + 'Google',
          content: {
            sir: $t('socialReviews.sir'),
            contentMail: '',
            deviseMail: $t('socialReviews.deviseMail'),
            sincerely: $t('socialReviews.sincerely')
          }
        }
      }
    ],
    linkFacebook: null,
    linkGoogle: null,
    mailContextEditing: {
      subject: { isEditing: false },
      sir: { isEditing: false },
      contentMail: { isEditing: false },
      deviseMail: { isEditing: false },
      linkMedia: { isEditing: false },
      sincerely: { isEditing: false }
    }
  },
  getters: {
    getListSuggestedReviews: (state) => state.listSuggestedReviews,
    getIsSuggestedLoadingState: (state) => state.suggestedLoadingState,
    getMailContextEditing: (state) => (name) => {
      return state.mailContextEditing[name].isEditing
    }
  },
  actions: {
    loadOnlyFacebookAndGoogleMedia (context) {
      const newList = context.state.listSuggestedReviews
      return HTTP_HYPER_ESPACE_BACKEND.get('/reviews/links/medias')
        .then((response) => {
          if (response.status === 200) {
            context.commit('setLinkFacebook', response.data)
            context.commit('setLinkGoogle', response.data)
            newList.forEach((suggestedReview) => {
              if (suggestedReview.name === 'Facebook') {
                suggestedReview.link = context.state.linkFacebook
              }
              if (suggestedReview.name === 'Google') {
                suggestedReview.link = context.state.linkGoogle
              }
            })
            context.commit('setListSuggestedReviews', newList)
          }
        }).catch((error) => {
          console.log(error)
        })
    },
    loadListSuggestedReviews (context, { sitimmoUser }) {
      const newList = context.state.listSuggestedReviews
      newList.forEach((suggestedReview) => {
        suggestedReview.mail.content.contentMail = (sitimmoUser.metier === 'CONCESSIONNAIRE') ? $t('socialReviews.contentMailVO') : $t('socialReviews.contentMailImmo')
      })
      context.commit('setListSuggestedReviews', newList)
    },
    sendMailForReceiver (context, { email }) {
      context.commit('setSuggestedLoadingState', true)
      let links = false
      const listHasCheckedExisting = context.state.listSuggestedReviews.filter((item) => item.checked)
      console.log('listHasCheckedExisting')
      console.log(listHasCheckedExisting)
      if (listHasCheckedExisting.length === 0) {
        message(
          {
            type: 'warning',
            message: $t('socialReviews.sendNetworkIsNotValid')
          }
        )
        context.commit('setSuggestedLoadingState', false)
      } else {
        const data = listHasCheckedExisting
        for (let i = 0; i < data.length; i++) {
          data[i].email = email
          if (data[i].link && data[i].link.match('https://')) {
            links = true
          }
        }
        if (links) {
          HTTP_HYPER_ESPACE_BACKEND
            .post('/mail/send-review', data)
            .then((response) => {
              message(
                {
                  type: 'success',
                  message: $t('socialReviews.sendMailSuccess')
                }
              )
              context.commit('resetAllChecked')
            })
            .catch((error) => {
              console.log(error)
              message(
                {
                  type: 'error',
                  message: $t('socialReviews.sendMailError')
                }
              )
            })
            .finally(() => {
              context.commit('setSuggestedLoadingState', false)
            })
        } else {
          message(
            {
              type: 'error',
              message: $t('socialReviews.sendMailErrorLinks')
            }
          )
          context.commit('setSuggestedLoadingState', false)
        }
      }
    }
  },
  mutations: {
    setListSuggestedReviews (state, list) {
      state.listSuggestedReviews = list
    },
    resetAllChecked (state) {
      state.listSuggestedReviews = state.listSuggestedReviews.map((obj) => {
        obj.checked = false
        return obj
      })
    },
    setSuggestedLoadingState (state, modifiedStatus) {
      state.suggestedLoadingState = modifiedStatus
    },
    setMailContextEditing (state, { property }) {
      state.mailContextEditing[property].isEditing = !state.mailContextEditing[property].isEditing
    },
    setLinkFacebook (state, { Facebook: link }) {
      state.linkFacebook = link
    },
    setLinkGoogle (state, { Google: link }) {
      state.linkGoogle = link
    }
  }
}
